/* eslint-disable prettier/prettier */
import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import workspace from './modules/workspace'
import lists from './modules/lists'
import users from './modules/users'
import companies from './modules/companies'
import exports from './modules/export'
import imports from './modules/import'
import deletes from './modules/delete'
import license from './modules/license'
import currentUser from './modules/currentUser'
import permissionsSelection from './modules/permissions'
import companiesUsers from './modules/Management/Accounts/CompaniesUsers'
import object from './modules/objects'
import images from './modules/images'
import home from './modules/Home/home'
import networkRules from './modules/Management/NetworkRules/networkRules'
import bestRoute from './modules/bestRoute'
import materials from './modules/Management/Stock/materials'
import cluster from './modules/cluster'
import networkDiagram from './modules/Home/networkDiagram'
import dynamicObjectForms from './modules/dynamicObjectForms'
import calculations from './modules/Home/calculations'
import masks from "./modules/masks";
import forms from './modules/Home/forms'
import activities from './modules/activities'
import labels from "./modules/Management/labels";
import processing from "@/store/modules/Home/processing";
import layers from "@/store/modules/layers";
import splitters from "@/store/modules/splitters";
import splicing from "@/store/modules/Home/splicing";
import assetReservation from "@/store/modules/assetReservation";
import changeLog from "@/store/modules/changeLog";
import listSettingsPaginationAndSearch from "@/store/modules/Management/PaginationAndSearch/listSettingsPaginationAndSearch";
import clientRoles from "./modules/clientRoles";
import twoFactorAuthentication from "./modules/twoFactorAuthentication";
import tickets from "@/store/modules/tickets";
import integrations from "@/store/modules/integrations";
import consumables from "@/store/modules/consumables";
import modules from "@/store/modules/modules";
import licenses from "@/store/modules/licenses";
import customListsAndFields from "@/store/modules/customListsAndFields";
import network from "@/store/modules/Network/network";
import workOrders from '@/store/modules/workOrders'
import buildingVerticalPlanning from '@/store/modules/Home/buildingVerticalPlanning';
import pathwayMicroducts from '@/store/modules/Home/pathwayMicroducts';
import simulations from './modules/simulations'
import multiselect from '@/store/modules/Home/multiselect';
import emailRecovery from './modules/emailRecovery'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
export const strict = false
export default new Vuex.Store({
  modules: {
    multiselect,
    auth,
    workspace,
    lists,
    users,
    companies,
    exports,
    imports,
    deletes,
    home,
    license,
    currentUser,
    permissionsSelection,
    companiesUsers,
    object,
    images,
    bestRoute,
    materials,
    networkRules,
    cluster,
    networkDiagram,
    dynamicObjectForms,
    calculations,
    masks,
    forms,
    activities,
    labels,
    processing,
    layers,
    splitters,
    splicing,
    assetReservation,
    changeLog,
    listSettingsPaginationAndSearch,
    tickets,
    clientRoles,
    twoFactorAuthentication,
    integrations,
    consumables,
    modules,
    licenses,
    customListsAndFields,
    network,
    workOrders,
    buildingVerticalPlanning,
    pathwayMicroducts,
    emailRecovery,
    simulations
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js